export const namespaced = true;

export const state = {
    loginModal: false,
    registroModal: false,
    gotoRoute: {name: 'jugar'}
};

export const mutations = {
    SET_LOGIN_STATE(state, estado) {
        state.loginModal = estado.state
        if (estado.goto != undefined) {
            state.gotoRoute = estado.goto
        }
    },
    SET_REGISTRO_STATE(state, estado) {
        state.registroModal = estado.state
        state.gotoRoute = { name: 'jugar' }
    }
};

export const actions = {
    loginOpen({commit}, goto){
        commit('SET_LOGIN_STATE', {state: true, goto: goto})
    },
    loginClose({commit}){
        commit('SET_LOGIN_STATE', {state: false})
    },
    registroOpen({commit}, goto){
        commit('SET_REGISTRO_STATE', {state: true, goto: goto})
    },
    registroClose({ commit }) {
        commit('SET_REGISTRO_STATE', {state: false})
    }
};

export const getters = {

};
